import React from 'react';
import { useLocation } from 'react-router';
import { BRAND } from '../mock/mockData.js';

export default function RefundPolicy() {
  const { pathname } = useLocation();
  const isAppMode = pathname === '/refund-policy-app';
  const termsLink = isAppMode ? '/terms-and-condition' : '/terms';

  return (
    <div className="legal">
      <h1>Refund Policy</h1>
      <p className="ldate">Last updated: 1 March 2025</p>
      <p>At TotalPe, we want you to be completely satisfied with our service. This Refund Policy outlines the terms and conditions for refunds on subscription plans and paid services.</p>

      <h2>1. Free Trial & Starter Plan</h2>
      <p>Our Starter plan is completely free with no credit card required. You can use TotalPe indefinitely on the Starter tier at no cost. There are no refunds needed as the plan is free.</p>

      <h2>2. Paid Plans (Professional & Enterprise)</h2>
      <p>For paid subscription plans (Professional and Enterprise), we offer a <strong>7-day money-back guarantee</strong> from the date of your first payment. If you're not satisfied with TotalPe's service within this period, you can request a full refund.</p>

      <h2>3. How to Request a Refund</h2>
      <p>To initiate a refund request, please contact our support team at <a href={`mailto:${BRAND.email}`} style={{ color:'var(--vivid)' }}>{BRAND.email}</a> or call <a href={`tel:${BRAND.phone}`} style={{ color:'var(--vivid)' }}>{BRAND.phone}</a> (Mon-Sat 10am-7pm IST). Provide the following details:</p>
      <ul>
        <li>Your business name and registered email address</li>
        <li>Reason for requesting the refund</li>
        <li>Date of subscription payment</li>
        <li>Transaction ID or receipt</li>
      </ul>

      <h2>4. Eligibility Criteria</h2>
      <p>Your refund request will be considered if:</p>
      <ul>
        <li>It is submitted within 7 days of your first payment</li>
        <li>You have not engaged in fraudulent activity or violated our <a href={termsLink} style={{ color:'var(--vivid)' }}>Terms & Conditions</a></li>
        <li>Your account is in good standing</li>
        <li>You have reasonably tested the service before requesting the refund</li>
      </ul>

      <h2>5. Processing Refunds</h2>
      <p>Once we receive and approve your refund request, we will process the refund to your original payment method within <strong>10 business days</strong>. Please note that your bank or payment provider may take an additional 3-5 business days to reflect the refund in your account.</p>

      <h2>6. Refunds After 7 Days</h2>
      <p>Subscription fees paid after the initial 7-day period are non-refundable. However, if you experience technical issues or service disruptions, we may offer account credits or service extensions instead of refunds. Contact our support team to discuss your situation.</p>

      <h2>7. Cancellation of Subscription</h2>
      <p>You can cancel your subscription anytime from your account settings. Cancellation takes effect at the end of your current billing cycle. No refunds are issued for partial months or unused portions of your subscription.</p>

      <h2>8. Account Issues & Technical Failures</h2>
      <p>If you encounter technical issues, service outages, or your data is lost due to our system failure, please report it immediately at <a href={`mailto:${BRAND.email}`} style={{ color:'var(--vivid)' }}>{BRAND.email}</a>. We will investigate and offer a resolution, which may include service credits, plan extensions, or in severe cases, a refund.</p>

      <h2>9. Chargebacks & Disputes</h2>
      <p>If you dispute a charge through your bank or payment provider without contacting us first, we may suspend your account. We encourage you to reach out to our support team to resolve billing issues before filing a chargeback.</p>

      <h2>10. Special Circumstances</h2>
      <p>If your business faces unexpected circumstances (permanent closure, natural disaster, etc.) within 30 days of purchase, we may consider a refund on a case-by-case basis. Please provide supporting documentation and contact us as soon as possible.</p>

      <h2>11. No Refunds for Add-ons or Integrations</h2>
      <p>Custom integrations, premium support packages, or third-party services added to your subscription are non-refundable. However, you can cancel these add-ons anytime and they will stop at the next billing cycle.</p>

      <h2>12. Contact Us</h2>
      <div className="lbox">
        <p style={{ margin:0 }}>
          <strong>For refund inquiries, contact:</strong><br/>
          Email: <a href={`mailto:${BRAND.email}`} style={{ color:'var(--vivid)' }}>{BRAND.email}</a>
          &nbsp;|&nbsp;Phone: <a href={`tel:${BRAND.phone}`} style={{ color:'var(--vivid)' }}>{BRAND.phone}</a><br/>
          Hours: Mon–Sat 10am–7pm IST<br/>
          Address: {BRAND.address}<br/>
          Response time: within 24 hours
        </p>
      </div>

      <h2>13. Changes to This Policy</h2>
      <p>We may update this Refund Policy from time to time. Changes will be communicated via email at least 15 days before taking effect. Continued use of TotalPe after changes implies acceptance of the updated policy.</p>
    </div>
  );
}
